import { useIsFranchisLogin } from "../../utils/userRoles"
import AdminDashboard from "./admin-dashboard"
import FODashboard from "./fo-dashboard"

function Dashboard(){
    const isFranchise=useIsFranchisLogin();
return(
    <>
    {
        isFranchise?<FODashboard/>:<AdminDashboard/>
        
    }
    </>
)
}
export default Dashboard